// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__32mjc","option":"styles_option__1YWfT","active":"styles_active__G4hjm"};